'use strict';
var parent = require('../../../stable/array/virtual/at');

module.exports = parent;
